<template>
  <div class="send-mix-tip">
    <el-dialog title="提示" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <div class="mix-tip">海关严令禁止混拼舱单的发送，否则会影响装载！</div>
        <p>系统检测到您正在发送的舱单属于混拼舱单！</p>
        <p>请立即<el-link type="primary" :underline="false" @click="toQQ">联系客服</el-link>进行处理，否则会影响出货速度～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" class="submit-btn" @click="closeDialog">知道了</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "SendMixTip",
  props: {
    visible: Boolean,
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'houseBillNo', label: '混拼分提单号'},
          { prop: 'containerNo', label: '混拼箱号'}
        ]
      }
    }
  },
  created() {
    this.WTableOpts.data = this.dialogData.content
  },
  methods: {
    // 联系客服
    toQQ(){
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    },
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    }
  }
}
</script>

<style scoped lang="less">
.send-mix-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 104px;
    padding: 0;
  }
  /deep/.el-dialog__body {
    position: relative;
    padding: 42px 24px 24px 24px !important;
  }
  .mix-tip {
    background: #fff5ed;
    color: #ed6a0c;
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding-left: 16px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
  /deep/.el-link {
    vertical-align: top;
  }
}
</style>